import { service } from ".";

export default {
  getAll: () => service.get("/statistics"),
  getOne: (id) => service.get(`/statistics/${id}`),
  getAllPaginate: (query) => service.get(`/statistics/paginate?${query}`),
  create: (data) => service.post("/statistics", data),
  update: (id, data) => service.put(`/statistics/${id}`, data),
  delete: (id) => service.delete(`/statistics/${id}`),
};
